import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";
import { lenisScroll } from "@/lib/scroll";

const FACTORS = ["Volume", "Editing Style", "Service Requirements", "Turnaround", "Recurring Workload", "Project Complexity"];
const STATS = ["Fast Turnaround", "Consistent Quality", "Global Delivery", "Scalable Volume"];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="bg-ivory text-ink py-28 md:py-40">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <FadeUp>
          <p className="text-[11px] md:text-xs uppercase tracking-[0.35em] text-bronze font-medium flex items-center gap-4">
            <span className="inline-block w-10 h-px bg-bronze" aria-hidden="true" />
            Pricing
          </p>
        </FadeUp>

        <h2 className="mt-8 font-display font-light text-4xl md:text-5xl lg:text-7xl leading-[0.98] tracking-tight">
          <MaskedLines lines={["CUSTOM PRICING.", "BUILT AROUND", "YOUR WORKFLOW."]} />
        </h2>

        <div className="mt-14 grid lg:grid-cols-12 gap-12">
          <FadeUp delay={0.15} className="lg:col-span-5">
            <p className="text-sm md:text-base text-ink/70 font-light leading-relaxed max-w-md">
              Every photographer, agency and property marketing team works differently.
              We provide customised pricing based on the way you work — never a
              one-size-fits-all rate card.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                data-testid="pricing-request-btn"
                onClick={() => lenisScroll("#contact")}
                className="inline-flex items-center gap-3 bg-ink text-ivory px-8 py-4 text-[11px] uppercase tracking-[0.25em] font-semibold transition-colors duration-300 hover:bg-bronze"
              >
                Request Custom Pricing
                <ArrowUpRight size={14} />
              </button>
              <button
                data-testid="pricing-send-project-btn"
                onClick={() => lenisScroll("#contact")}
                className="inline-flex items-center gap-3 border border-ink/30 text-ink px-8 py-4 text-[11px] uppercase tracking-[0.25em] font-semibold transition-colors duration-300 hover:border-bronze hover:text-bronze"
              >
                Send Us Your Project
              </button>
            </div>
          </FadeUp>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
            {FACTORS.map((f, i) => (
              <FadeUp key={f} delay={0.06 * i} className="bg-ivory">
                <div className="px-6 py-7 flex items-center justify-between">
                  <span className="text-[11px] uppercase tracking-[0.3em] text-ink/80">{f}</span>
                  <span className="font-display text-bronze">0{i + 1}</span>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>

        <FadeUp delay={0.2} className="mt-20 border-t border-ink/10 pt-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s) => (
            <div key={s} data-testid={`stat-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <span className="block w-8 h-px bg-bronze mb-4" />
              <p className="text-xs uppercase tracking-[0.3em] text-ink/70">{s}</p>
            </div>
          ))}
        </FadeUp>
      </div>
    </section>
  );
}
